var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.data.columns),function(col,index){return _c('b-col',{key:("columna-" + index)},[(col.element)?_vm._t("default",[_c(col.element.tag,_vm._b({tag:"component"},'component',{data: col.element},false))]):_vm._e()],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }